/**
 * Regional configuration for the holds request system
 * Centralized definition of supported regions
 */

export const REGIONS = {
  WEST: 'West',
  CENTRAL: 'Central',
  EAST: 'East'
} as const;

export type Region = typeof REGIONS[keyof typeof REGIONS];

export const REGION_LIST: Region[] = Object.values(REGIONS);

export const REGION_CODES = {
  [REGIONS.WEST]: 'W',
  [REGIONS.CENTRAL]: 'C',
  [REGIONS.EAST]: 'E'
} as const;

/**
 * Validates if a given string is a valid region
 */
export function isValidRegion(region: string): region is Region {
  return REGION_LIST.includes(region as Region);
}

/**
 * Gets the region code for a given region
 */
export function getRegionCode(region: Region): string {
  return REGION_CODES[region];
}